// extracted by mini-css-extract-plugin
export default {"root":"CopyMessageTool_root__O5RIB"};